import Axios from 'axios';
import {AppError} from '@/shared/models';

const axios = Axios.create({
  baseURL:  process.env.NODE_ENV === 'production'
    ? '/app/'
    : '/',
});

axios.interceptors.request.use(
    config => {
      const accessToken = store.getters['main/accessToken'];
        console.debug('Axios Request : ',accessToken, config,process.env);

        if(accessToken && accessToken.value && accessToken.type === 'JSESSIONID') {
            document.cookie = `JSESSIONID=${accessToken.value}`;
            config.headers = {
                //'Authorization': `Bearer ${accessToken.value}`,
                'Accept': 'application/json'
            };
        }

        return config;
    },
    reason => {
        console.error(reason.response);
        throw new AppError(typeof(reason.response.data) === 'string' ? reason.response.data : reason.response.data.message,reason.response);
    }
);

axios.interceptors.response.use(
    response => response,
    reason => {
        console.error(reason.response);
        throw new AppError(typeof(reason.response.data) === 'string' ? reason.response.data : reason.response.data.message,reason.response);
    }
);

export default axios;
